import React from 'react';
import ImageMockup from './ImageMockup';
import TriangleDown from '../../asset/TriangleDown';
import Caption from '../Caption';

// image grid uses image tags
const ImageGridx3 = ({first, second, third, caption, themeColor, showTriangle, innerDescription, extra}) => (
  <section>
    <div className="grid" style={{backgroundColor: themeColor,}}>
      <div className="container">
        {showTriangle && <TriangleDown style={{fill: 'white'}}/>}

        {/* Description */}
        {innerDescription !== undefined
          ? <div>{innerDescription} </div>
          : null}

        <div className="wrap">
          <div className="col col-1 col-1-2--m">
            <ImageMockup image={third} caption={caption}/>
          </div>
          <div className="col col-1 col-1-2--m">
            <ImageMockup image={second} caption={caption}/>
          </div>
          <div className="col col-1">
            <ImageMockup image={first} caption={caption}/>
          </div>
        </div>

        {caption !== undefined
          ? <Caption captionText={caption}/>
          : null
        }

        {extra !== undefined
          ? <div className="grid">
              <div className="container extra-padding-bottom">
                  <div className="wrap">
                    {extra}
                  </div>
              </div>
            </div>
          : null }

      </div>
    </div>
  </section>
);

export default ImageGridx3;



// WEBPACK FOOTER //
// ./src/layout/portfolio/ImageGridx3.js